import { useTranslation } from "react-i18next";

type ListViewSkeletonProps = {
  /** Column headers to show above skeleton rows */
  columns: { label: string; flex: string }[];
  /** Number of skeleton rows to render */
  rows?: number;
  /** Show a checkbox placeholder in the first column (for Tasks) */
  showCheckbox?: boolean;
};

const SkeletonBar = ({ className = "" }: { className?: string }) => (
  <div className={`h-3 bg-gray-200 rounded animate-pulse ${className}`} />
);

export default function ListViewSkeleton({
  columns,
  rows = 6,
  showCheckbox = false,
}: ListViewSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col gap-3">
      {/* Header */}
      <div className="w-full">
        <div className="flex items-center justify-start gap-2 py-2 bg-gray-100">
          {showCheckbox && <div className="w-4 h-4" />}
          {columns.map((col) => (
            <div
              key={col.label}
              className={`${col.flex} ${columns.indexOf(col) === 0 && !showCheckbox ? "pl-4" : ""}`}
            >
              {t(col.label)}
            </div>
          ))}
        </div>
      </div>

      {/* Skeleton rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-2 py-2.5 px-1"
          style={{ opacity: 1 - i * 0.12 }}
        >
          {showCheckbox && (
            <div className="w-4 h-4 rounded-sm border border-gray-200 bg-gray-100 animate-pulse" />
          )}
          {columns.map((col, ci) => (
            <div key={ci} className={col.flex}>
              {ci === 0 ? <SkeletonBar className="w-3/4" /> : <SkeletonBar className="w-1/2" />}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
